import {
	type AIConversationCallView,
	useSalesLiveCoachingConversationByIdQuery,
} from './useSalesLiveCoachingConversationsQuery';

/** Resolves a single coaching conversation's call view for the detail panels, deep-link safe. */
export function useCoachingConversationCallView(conversationId: string | null): {
	callView: AIConversationCallView | undefined;
	isLoading: boolean;
	notFound: boolean;
} {
	const byIdQuery = useSalesLiveCoachingConversationByIdQuery({ id: conversationId ?? '' });

	const callView = byIdQuery.data;
	const isLoading = Boolean(conversationId) && !callView && byIdQuery.isLoading;
	// The by-id route 404s when the id doesn't exist or isn't a coaching conversation — surfaced as a
	// dedicated "not found" state (e.g. a stale/invalid `?convo=` deep link) rather than a toast.
	const notFound =
		Boolean(conversationId) && byIdQuery.isError && (byIdQuery.error as { systemCode?: number })?.systemCode === 404;

	return { callView, isLoading, notFound };
}
